import { GrowthBook } from "@growthbook/growthbook";
import { autoAttributesPlugin } from "@growthbook/growthbook/plugins";

let amplitude = null;

const queryParams = new URLSearchParams(window.location.search);
const userCountryQueryParam = queryParams.get("user_country") || "";
let variationId = null;

const gbInstance = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: process.env.GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  plugins: [autoAttributesPlugin()],

  trackingCallback: (experiment, result) => {
    console.log(`trackingCallback experiment: ${experiment}`);
    try {
      // --- Amplitude ---
      if (amplitude && typeof amplitude.track === "function") {
        amplitude.track("Experiment Viewed", {
          experiment_key: experiment.key,
          variant_key: result.key,
          experiment_id: experiment.id || experiment.key,
          variant_id: result.id || result.key,
        });
        variationId = Number(result.id) || Number(result.key);
        console.debug("[GrowthBook] Sent event to Amplitude");
      } else {
        console.debug("[GrowthBook] Amplitude not found - skipping");
      }

      // --- Google Analytics ---
      if (typeof window?.gtag === "function") {
        window?.gtag("event", "experiment_viewed", {
          experiment_key: experiment.key,
          variant_key: result.key,
        });
        console.debug("[GrowthBook] Sent event to GA");
      } else {
        console.debug("[GrowthBook] GA not found - skipping");
      }
    } catch (err) {
      console.warn("[GrowthBook] tracking error", err);
    }
    console.info("[GrowthBook] exposure:", experiment.key, result.key);
    // store.commit("setGrowthbookVariationId", result.variationId);
  },
});

export const initializeGrowthBook = async () => {
  amplitude = window._amplitude?._amplitudeInstance || window?.amplitude;

  try {
    const { countryCode } = await getUserCountry();

    if (amplitude) {
      gbInstance.updateAttributes({
        user_id: amplitude?.getDeviceId(),
        user_country: countryCode || userCountryQueryParam,
      });
    }

    await gbInstance.init({ streaming: true });

    console.info(
      "[GrowthBook] initialized, attributes:",
      gbInstance.getAttributes()
    );
    return gbInstance;
  } catch (e) {
    console.error("GrowthBook init error", e);
    return null;
  }
};

(function hideContent() {
  document.querySelector("body").style.visibility = "hidden";
})();

function showContent() {
  document.querySelector("body").style.visibility = "visible";
}

async function getUserCountry() {
  const API_URL = process.env.API_URL;

  if (!API_URL) {
    throw new Error("API_URL is not defined");
  }

  try {
    const response = await fetch(`${API_URL}/api/v1.4/customer-address`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch customer address: ${response.status}`);
    }

    const { countryCode, postCode } = await response.json();
    return { countryCode, postCode };
  } catch (error) {
    console.error("Error fetching customer address: ", error);
    return { success: false, error: error.message };
  }
}

setTimeout(() => {
  initializeGrowthBook()
    .then((gbInstance) => {
      if (!variationId) {
        showContent();
      } else {
        setTimeout(() => {
          showContent();
        }, 500);
      }
    })
    .finally(() => {
      console.log("GB__initializeGrowthBook");
    });
}, 0);
